<template>
  <div>
    <px-lista-requisicao-produtos-header :on-click-refresh="onClickRefresh"
                                         :produtos="localValue"
                                         @change="onChangeFilter"
                                         @remove="onRemoveItem"/>
    <px-lista-requisicao-produtos-list :produtos="produtos"
                                       :options-list="optionsList"
                                       :loading="loading"
                                       v-model="localValue"
                                       :on-change-options="onChangeOptions"/>
  </div>

</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  RESET_PAGINATION,
  SET_FILTER_ACTION,
  SET_LIST_OPTIONS_ACTION,
  INIT_STATE_ACTION,
  SET_CURRENT_SESSION_STATE_ACTION,
} from '@/store/requisicao-geracao/actions.type';
import RequisicoesService from '@/modules/requisicao/requisicoes-service';
import paginationMixin from '@/mixins/pagination-mixin';
import ListaRequisicaoProdutosList from './ListaRequisicaoProdutosList.vue';
import ListaRequisicaoProdutoHeader from './ListaRequisicaoProdutoHeader.vue';

export default {
  mixins: [paginationMixin],
  props: {
    value: Array,
  },
  data() {
    return {
      loading: false,
      filters: {},
      produtos: {
        content: [],
        total: 0,
      },
      optionsList: {},
    };
  },
  computed: {
    ...mapGetters('requisicaoGeracao', ['stringFilter', 'listOptions']),
    ...mapGetters('entidade', ['idEntidade']),
    ...mapGetters('user', ['user']),
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  methods: {
    ...mapActions('requisicaoGeracao', {
      resetPagination: RESET_PAGINATION,
      updateFilter: SET_FILTER_ACTION,
      updateOptions: SET_LIST_OPTIONS_ACTION,
      initState: INIT_STATE_ACTION,
      setCurrentSessionState: SET_CURRENT_SESSION_STATE_ACTION,
    }),
    onChangeFilter() {
      this.resetPage();
      this.getRequisicaoProdutos();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.updateOptions(this.optionsToPage(this.listOptions, this.optionsList));
      this.getRequisicaoProdutos();
    },
    resetPage() {
      this.resetPagination();
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    onClickRefresh() {
      this.getRequisicaoProdutos();
    },
    getRequisicaoProdutos() {
      this.loading = true;

      this.updateFilter(this.stringFilter);

      const { limit, offset } = this.listOptions;
      RequisicoesService.getRequisicoesProdutos({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then(({ data }) => {
          this.produtos = data;
        })
        .finally(() => {
          this.setCurrentSessionState({
            idCurrentEntidade: this.idEntidade,
            idCurrentUser: this.user.id,
          });
          this.loading = false;
        });
    },
    onRemoveItem(requisicaoProduto) {
      if (!this.localValue || !this.localValue.length) {
        return;
      }
      const index = this.localValue.findIndex(r => r.id === requisicaoProduto.id);
      this.localValue.splice(index, 1);
    },
  },
  created() {
    this.initState({
      idCurrentEntidade: this.idEntidade,
      idCurrentUser: this.user.id,
    });
    this.optionsList = this.pageToOptions(this.listOptions);
  },
  components: {
    pxListaRequisicaoProdutosList: ListaRequisicaoProdutosList,
    pxListaRequisicaoProdutosHeader: ListaRequisicaoProdutoHeader,
  },
};
</script>
